import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, CircularProgress } from '@mui/material';

import AppAlert from '../../designe/app-alert/AppAlert';
import AppButton from '../../designe/buttons/app-button/AppButton';

export interface ILoadMoreFeedbackProps {
  error: unknown;
  isFetching: boolean;
  onRetry: () => void;
}

const LoadMoreFeedback = ({
  error,
  isFetching,
  onRetry,
}: ILoadMoreFeedbackProps) => {
  const { t } = useTranslation();

  if (!error && !isFetching) return null;

  return (
    <>
      {error && (
        <AppAlert
          severity="error"
          action={
            <AppButton size="small" onClick={onRetry}>
              {t('common.retry')}
            </AppButton>
          }
          sx={{ mt: 1 }}>
          {t('common.loadMoreError')}
        </AppAlert>
      )}
      {isFetching && (
        <Box display="flex" justifyContent="center" py={2}>
          <CircularProgress size={24} />
        </Box>
      )}
    </>
  );
};

export default LoadMoreFeedback;
